import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Wrapper } from '~/styles/Wrapper.styled';
import { StyledIngredients } from './Ingredients.styled';
import { ProductIngredient } from '~/types/types';

export const Ingredients: React.FC<IngredientsData> = ({
  title,
  ingredients,
}) => {
  return (
    <StyledIngredients>
      <Wrapper>
        <h3>{title}</h3>

        <div className="content">
          <div className="ingredients-prev"></div>

          <Swiper
            navigation={{
              prevEl: '.ingredients-prev',
              nextEl: '.ingredients-next',
            }}
            pagination={{
              clickable: true
            }}
            loop
            spaceBetween={18}
            loopedSlides={ingredients.length}
            slidesPerView="auto"
            modules={[Navigation, Pagination]}
          >
            {ingredients.map((ingredient, i) => {
              return (
                <SwiperSlide key={`ingredient-${i}`}>
                  <figure>
                    <GatsbyImage
                      image={ingredient.image.gatsbyImageData}
                      alt={ingredient.image.title}
                    />
                  </figure>

                  <div className="name">{ingredient.label}</div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <div className="ingredients-next"></div>
        </div>
      </Wrapper>
    </StyledIngredients>
  );
};

export interface IngredientsData {
  title: string;
  ingredients: ProductIngredient[];
}
